import { render, staticRenderFns } from "./Duplicates.vue?vue&type=template&id=84810474&"
import script from "./Duplicates.vue?vue&type=script&lang=ts&"
export * from "./Duplicates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports